let formModel = {
    full_name: '',
    federation: '', 
    media:''
}
export default formModel;